import React from 'react';
import styles from "../pagedata/styles/gallerysubmodule.module.css";
import { motion } from 'framer-motion';

const GalleryCard = ({ photo }) => {
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const isBackendPath = photo.path?.startsWith('/uploads');
  const imageUrl = isBackendPath
    ? `${apiBaseUrl.replace('/api', '')}${photo.path}`
    : photo.thumbnail || photo.path;

  return (
    <motion.div
      className={styles['photo-item']}
      initial="hidden"
      animate="visible"
      variants={cardVariants}
    >
      <img
        src={imageUrl}
        alt={photo.title}
        loading="lazy"
        className={styles.cardImage}
      />
      <h3>{photo.title}</h3>
      <p>{photo.description}</p>
    </motion.div>
  );
};

export default GalleryCard;
